import type {
  AllPropTypes,
  ArrayOfT,
  ExactT,
  InstanceOfT,
  ObjectOfT,
  OneOfT,
  OneOfTypeT,
  ParametizedPropTypes,
  ReactDescT,
  ShapeT,
} from './types.js';

export const hasArguments = (propType: ReactDescT, realPropType: AllPropTypes): realPropType is ParametizedPropTypes =>
  !!propType.args;

export const isOneOfType = (propType: ReactDescT, realPropType: AllPropTypes): realPropType is OneOfTypeT =>
  propType.type === 'oneOfType';

export const isArrayOf = (propType: ReactDescT, realPropType: AllPropTypes): realPropType is ArrayOfT =>
  propType.type === 'arrayOf';

export const isShape = (propType: ReactDescT, realPropType: AllPropTypes): realPropType is ShapeT =>
  propType.type === 'shape';

export const isInstanceOf = (propType: ReactDescT, realPropType: AllPropTypes): realPropType is InstanceOfT =>
  propType.type === 'instanceOf';

export const isOneOf = (propType: ReactDescT, realPropType: AllPropTypes): realPropType is OneOfT =>
  propType.type === 'oneOf';

export const isObjectOf = (propType: ReactDescT, realPropType: AllPropTypes): realPropType is ObjectOfT =>
  propType.type === 'objectOf';

export const isExact = (propType: ReactDescT, realPropType: AllPropTypes): realPropType is ExactT =>
  propType.type === 'exact';
